/** Resolve the signed-in user's id for API calls that still require userId in the body. */
export function resolveCurrentUserId(userData?: any): string {
  const fromProfile = [
    userData?.uid,
    userData?.userId,
    userData?.UserId,
    userData?.id,
    userData?.Id,
  ]
    .map((value) => (value == null ? "" : String(value).trim()))
    .find(Boolean);
  if (fromProfile) return fromProfile;

  if (typeof window === "undefined") return "";
  try {
    const auth = JSON.parse(localStorage.getItem("authUser") || "{}");
    return (
      [auth.uid, auth.userId, auth.UserId, auth.id, auth.Id]
        .map((value) => (value == null ? "" : String(value).trim()))
        .find(Boolean) || ""
    );
  } catch {
    return "";
  }
}
